import React from 'react';
import { FaThLarge, FaShareAlt, FaTrash } from 'react-icons/fa';

const extractYouTubeVideoID = (url) => {
  const regExp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/;
  const match = url.match(regExp);
  return match ? match[1] : "";
};

const RunCard = ({
  run,
  onClick,
  onDelete,
  onShare,
  showSelect,
  getGradientForRun // Optional, for homepage
}) => {
  const hasThumbnail = !!run.youtubeUrl;
  // Fixed width for all cards
  const cardWidth = 280;
  // Use getGradientForRun if provided, fallback to teal
  const placeholderBg =
    typeof getGradientForRun === "function"
      ? getGradientForRun(run.id)
      : "#13A1A8";
  // Thumbnail/placeholder heights
  const thumbHeight = 160;

  return (
    <div
      style={{
        background: "#fff",
        border: '1px solid #e0e0e0',
        borderRadius: '10px',
        padding: '14px',
        margin: '6px',
        color: '#222',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: cardWidth,
        minWidth: cardWidth,
        maxWidth: cardWidth,
        boxSizing: "border-box",
        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
        cursor: onClick ? 'pointer' : 'default',
        transition: "box-shadow 0.2s",
        position: "relative"
      }}
      onClick={onClick}
    >
      {hasThumbnail ? (
        <img
          src={`https://img.youtube.com/vi/${extractYouTubeVideoID(run.youtubeUrl)}/hqdefault.jpg`}
          alt="Run thumbnail"
          style={{
            width: '100%',
            height: thumbHeight,
            objectFit: "cover",
            borderRadius: '6px',
            marginBottom: '12px',
            background: "#eee"
          }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: thumbHeight,
            background: placeholderBg,
            borderRadius: '6px',
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '32px',
            color: '#fff'
          }}
        >
          <FaThLarge size={44} />
        </div>
      )}
      <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: "3px", color: "#222" }}>
        {run.runName || 'Unnamed Run'}
      </div>
      <div style={{
        fontSize: '12px',
        color: '#666',
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between"
      }}>
        <span>{run.date}</span>
        {/* Share and Delete buttons */}
        <span style={{ display: "flex", gap: "8px", marginLeft: "auto" }}>
          {onShare && (
            <button
              title="Share"
              style={{
                background: "none",
                border: "none",
                color: "#13A1A8",
                cursor: "pointer",
                padding: "2px 4px",
                borderRadius: "4px"
              }}
              onClick={e => {
                e.stopPropagation();
                onShare();
              }}
            >
              <FaShareAlt size={13} />
            </button>
          )}
          {onDelete && (
            <button
              title="Delete"
              style={{
                background: "none",
                border: "none",
                color: "#FE6C62",
                cursor: "pointer",
                padding: "2px 4px",
                borderRadius: "4px"
              }}
              onClick={e => {
                e.stopPropagation();
                onDelete();
              }}
            >
              <FaTrash size={13} />
            </button>
          )}
        </span>
      </div>
      {showSelect && (
        <button
          className="select-btn"
          onClick={e => { e.stopPropagation(); onClick?.(); }}
          style={{
            marginTop: '12px',
            alignSelf: 'flex-end',
            background: "#13A1A8",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            padding: "6px 14px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          Select
        </button>
      )}
    </div>
  );
};

export default RunCard;